import { render } from "./productDetailBase.vue?vue&type=template&id=634a6692&scoped=true"
import script from "./productDetailBase.vue?vue&type=script&lang=js"
export * from "./productDetailBase.vue?vue&type=script&lang=js"

import "./productDetailBase.vue?vue&type=style&index=0&id=634a6692&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634a6692"],['__file',"src/views/product/components/productDetailBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "634a6692"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('634a6692', __exports__)) {
    api.reload('634a6692', __exports__)
  }
  
  module.hot.accept("./productDetailBase.vue?vue&type=template&id=634a6692&scoped=true", () => {
    api.rerender('634a6692', render)
  })

}


export default __exports__